document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[data-rudra-header]");
  const menuButton = document.querySelector("[data-rudra-menu-button]");
  const menuCloseButton = document.querySelector("[data-rudra-menu-close]");
  const mobileDrawer = document.querySelector("[data-rudra-mobile-menu]");
  const mega = document.querySelector("[data-rudra-mega]");
  const megaTrigger = document.querySelector("[data-rudra-mega-trigger]");
  const megaPanel = document.querySelector("[data-rudra-mega-panel]");
  let lastMenuTrigger = null;

  const updateHeader = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  };

  const closeMobileDrawer = () => {
    if (!mobileDrawer || !menuButton) return;
    mobileDrawer.classList.remove("is-open");
    mobileDrawer.setAttribute("aria-hidden", "true");
    menuButton.setAttribute("aria-expanded", "false");
    document.body.classList.remove("rudra-menu-open");
    document.body.classList.remove("rudra-drawer-open");

    if (lastMenuTrigger) {
      lastMenuTrigger.focus();
      lastMenuTrigger = null;
    }
  };

  const openMobileDrawer = () => {
    if (!mobileDrawer || !menuButton) return;
    lastMenuTrigger = document.activeElement === menuButton ? menuButton : null;
    mobileDrawer.classList.add("is-open");
    mobileDrawer.setAttribute("aria-hidden", "false");
    menuButton.setAttribute("aria-expanded", "true");
    document.body.classList.add("rudra-menu-open");
    document.body.classList.add("rudra-drawer-open");

    const firstLink = mobileDrawer.querySelector("a, button");
    if (firstLink) {
      window.setTimeout(() => firstLink.focus(), 80);
    }
  };

  const closeMega = () => {
    if (!mega || !megaTrigger) return;
    mega.classList.remove("is-open");
    megaTrigger.setAttribute("aria-expanded", "false");
  };

  const openMega = () => {
    if (!mega || !megaTrigger) return;
    mega.classList.add("is-open");
    megaTrigger.setAttribute("aria-expanded", "true");
  };

  updateHeader();
  window.addEventListener("scroll", updateHeader);

  if (menuButton) {
    menuButton.addEventListener("click", () => {
      openMobileDrawer();
    });
  }

  if (menuCloseButton) {
    menuCloseButton.addEventListener("click", closeMobileDrawer);
  }

  if (mobileDrawer) {
    mobileDrawer.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMobileDrawer);
    });

    mobileDrawer.querySelectorAll("[data-rudra-search-open], [data-rudra-cart-open]").forEach((button) => {
      button.addEventListener("click", closeMobileDrawer);
    });
  }

  if (mega && megaTrigger && megaPanel) {
    megaTrigger.addEventListener("click", () => {
      if (mega.classList.contains("is-open")) {
        closeMega();
      } else {
        openMega();
      }
    });

    mega.addEventListener("mouseenter", openMega);
    mega.addEventListener("mouseleave", closeMega);

    document.addEventListener("click", (event) => {
      if (!mega.contains(event.target)) {
        closeMega();
      }
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMobileDrawer();
      closeMega();
    }
  });
});
